import { stringify } from '@0xtorch/core'
import type { TransactionDetail } from '@0xtorch/solana'

export const saveTransactionLog = async (args: {
  endpoint: string
  getToken: () => Promise<string | null>
  transaction: TransactionDetail
}) => {
  const { endpoint, getToken, transaction } = args

  const token = await getToken()
  if (token === null) {
    return
  }

  const url = new URL('/v1/log/solana-transaction', endpoint)
  const response = await fetch(url.toString(), {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: stringify(transaction),
  })

  if (!response.ok) {
    throw new Error('Failed to save transaction log')
  }
}
